import React, { Component } from 'react'
import {Form, Input, Select, Button, message, Radio, Row, Col, Modal} from 'antd'
import {getClaimInfoList, updateClaimInfoList, submitClaimInfo} from '@service/report'
import './style.scss'
import AmountItemsTable from "../../../lossAss/containers/ReportDetail/DanNiaoReportDetailFoot/amount-items-table.js";
import AmountItemsTableClaim from "../../../lossAss/containers/ReportDetail/DanNiaoReportDetailFoot/amount-items-table-claim";
import {autoCalculateClaimAmount} from "../../../lossAss/containers/ReportDetail/autoCalculate";

const { Option } = Select
const { TextArea } = Input
const { RadioGroup, RadioButton } = Radio
const config = process.env || {};

const lossTypeEnum = {
    injury: "人伤",
    carLoss: "车损",
    damage:"物损"
}

// 内部核赔状态
const innerClaimStatusEnum = {
    PENDING_CLAIM: '待提交核赔',
    PENDING: '待领取',
    REVIEWING: '审核中',
    APPROVED: '审核通过',
    REJECTED: '审核驳回'
}
// 保险方核赔状态
const insureCompClaimStatusEnum = {
    INSURE_PENDING: '待核赔',
    INSURE_REJECTED: '核赔驳回',
    INSURE_APPROVED: '已核赔',
    INSURE_PAID_SUCCESS: '支付完成',
    INSURE_PAYMENT_FAILED: '支付失败'
}

const paymentStatusEnum = {
    1: '支付完成',
    2: '支付失败',
    toRemitt: '待打款',
    remitted: '支付完成',
    reRemitt: '重新打款',
    refound: '支付失败'
}

// 理算信息组件
class ClaimInfoList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedKey: 0,
            claimInfoList: [],
            paymentInfoList: [],
            selectList:[],
            loading: false,
            initLoading: true,
            flowId: null,
            agentId: null,
            lossId: null,
            lossType: null,
            visibleMoney: false
        }
    }

    componentDidMount() {
        this.loadData()
        window.addEventListener('message', this.receiveMessage, false);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
    }
    receiveMessage = async (event) => {
        const data = event.data;
        if (data.eventName === 'refreshReport') {
            this.loadData()
        }
    };

    loadData = async () => {
        const { flowId } = this.props
        if (!flowId) {
            this.setState({ initLoading: false })
            return
        }

        try {
            const result = await getClaimInfoList({ flowId })
            if (result.errCode === 0 && result.result) {
                const claimInfoList = (result.result.claimInfoList || []).map(item => ({ ...item, isNew: false }))
                this.setState({
                    claimInfoList,
                    // selectedKey: claimInfoList.length > 0 ? 0 : null,
                    paymentInfoList: result.result.paymentInfoList,
                    selectList: result.result.selectList,
                    initLoading: false
                })
            } else {
                message.error(result.msg || '获取数据失败')
                this.setState({ initLoading: false })
            }
        } catch (err) {
            message.error('获取数据失败')
            this.setState({ initLoading: false })
        }
    }

    hasNewItem = () => {
        const { claimInfoList } = this.state
        return claimInfoList.some(item => item.isNew)
    }

    handleAdd = () => {
        if (this.props.disabled) {
            message.warning('权限不足')
            return
        }
        if (this.hasNewItem()) {
            message.warning('请先保存当前新增的计算书信息')
            return
        }
        const { claimInfoList } = this.state
        const newList = [...claimInfoList, {
            claimBookNo: "",
            innerClaimStatus:"",
            insureCompClaimStatus:"",
            innerRejectReason:"",
            insureCompRejectReason:"",
            isPreMatch:"",
            opinion:"",
            lossList: [],
            isNew: true
        }]
        this.setState({
            claimInfoList: newList,
            selectedKey: newList.length - 1
        })
    }

    handleSelect = (index) => {
        this.setState({ selectedKey: index })
    }

    addLossItemClick = () => {
        const { selectedKey, claimInfoList } = this.state
        if (selectedKey === null) return

        const newClaimInfoList = [...claimInfoList]
        const currentClaim = { ...newClaimInfoList[selectedKey] }
        const newLossList = currentClaim.lossList ? [...currentClaim.lossList] : []
        
        newLossList.push({
            lossId: undefined,
            lossType: undefined,
            paymentId: undefined,
            claimResps: []
        })
        
        currentClaim.lossList = newLossList
        newClaimInfoList[selectedKey] = currentClaim
        this.setState({ claimInfoList: newClaimInfoList })
    }

    canSubmitClaim = (claimItem) => {
        let innerCanUpdateStatus = [
            "PENDING_CLAIM",
            "REJECTED",
        ]
        let insureCanUpdateStatus = [
            "INSURE_REJECTED",
            "INSURE_PAYMENT_FAILED",
        ]
        if (innerCanUpdateStatus.includes(claimItem.innerClaimStatus)) {
            // 包含状态并且有计算书号
            return claimItem.claimBookNo
        }
        if (insureCanUpdateStatus.includes(claimItem.insureCompClaimStatus)) {
            return claimItem.claimBookNo
        }
    }

    getReviewOpinion = (claimItem = {}) => {
        if (claimItem.innerClaimStatus === 'REJECTED') {
            return claimItem.innerRejectReason || ''
        }
        if (['INSURE_REJECTED', 'INSURE_PAYMENT_FAILED'].includes(claimItem.insureCompClaimStatus)) {
            return claimItem.insureCompRejectReason || ''
        }
        return ''
    }

    canSubmit = (claimItem) => {
        let innerCanUpdateStatus = [
            "PENDING_CLAIM",
            "REJECTED",
        ]
        let insureCanUpdateStatus = [
            "INSURE_REJECTED",
            "INSURE_PAYMENT_FAILED",
        ]
        if (!claimItem.claimBookNo) {
            return true //新增
        }
        if (innerCanUpdateStatus.includes(claimItem.innerClaimStatus)) {
            // 包含状态并且有计算书号
            return true
        }
        if (insureCanUpdateStatus.includes(claimItem.insureCompClaimStatus)) {
            return true
        }
    }

    removeLossItemClick = (index) => {
        const { selectedKey, claimInfoList } = this.state
        if (selectedKey === null) return

        const newClaimInfoList = [...claimInfoList]
        const currentClaim = { ...newClaimInfoList[selectedKey] }
        const newLossList = currentClaim.lossList ? [...currentClaim.lossList] : []
        
        if (index > -1 && index < newLossList.length) {
            newLossList.splice(index, 1)
        }
        
        currentClaim.lossList = newLossList
        newClaimInfoList[selectedKey] = currentClaim
        this.setState({ claimInfoList: newClaimInfoList })
    }

    handleFieldChange = (field, value, index) => {
        const { selectedKey, claimInfoList } = this.state
        if (selectedKey === null) return
        
        const newClaimInfoList = [...claimInfoList]
        const currentClaim = { ...newClaimInfoList[selectedKey] }
        const newLossList = currentClaim.lossList ? [...currentClaim.lossList] : []
        
        if (index >= 0 && index < newLossList.length) {
            if (field === 'lossId') {
                //如果更新损失方，重置损失类型选择
                newLossList[index] = { ...newLossList[index], [field]: value, lossType: undefined }
            } else {
                newLossList[index] = { ...newLossList[index], [field]: value }
            }
        }
        
        currentClaim.lossList = newLossList
        newClaimInfoList[selectedKey] = currentClaim
        this.setState({ claimInfoList: newClaimInfoList })
    }

    getLossMetaByLossId = (initialValues = {}, lossId) => {
        const targetLossId = lossId != null ? lossId.toString() : ''
        const { ownCarLoss = {}, otherCarLoss = [] } = initialValues || {}

        if (ownCarLoss && ownCarLoss._id && ownCarLoss._id.toString() === targetLossId) {
            return {
                source: 'owner',
                carOwner: ownCarLoss.carOwner || '',
                lossType: ownCarLoss.lossType || '',
                loss: ownCarLoss
            }
        }

        for (const loss of otherCarLoss) {
            if (loss && loss._id && loss._id.toString() === targetLossId) {
                return {
                    source: 'other',
                    carOwner: loss.carOwner || '',
                    lossType: loss.lossType || '',
                    loss
                }
            }
        }

        return {
            source: 'other',
            carOwner: '',
            lossType: '',
            loss: null
        }
    }

    viewEditAmountItems = (initialValues, currentAgent, source, lossId, lossType, carOwner) => {
        const url = `/edit-amount-items?flowId=${initialValues.flowId}&agentId=${currentAgent._id}&lossId=${lossId}&lossType=${lossType || ''}&source=${source}&carOwner=${carOwner}&token=${window.btoa(window.accessToken)}`;
        var popup = window.open(`/iframe/${encodeURIComponent(url)}`)
        setTimeout(() => {
            popup.postMessage(
                {
                    flowId: initialValues.flowId,

                    eventName: 'viewEditAmountItems'
                },
                '*'
            );
        }, 2000);
    };

    editClaimCode = async (initialValues, currentAgent, lossId, lossType) => {
        const isSave = await this.onSave()
        if (!isSave) {
            return
        }
        const { source, carOwner } = this.getLossMetaByLossId(initialValues, lossId)
        this.viewEditAmountItems(initialValues, currentAgent,source, lossId, lossType, carOwner)
    }

    showModalMoney = (flowId, agentId, lossId, lossType = '') => {
        const missingKeys = [];
        if (!flowId) missingKeys.push('flowId');
        if (!agentId) missingKeys.push('agentId');
        if (!lossId) missingKeys.push('lossId');
        if (!lossType) missingKeys.push('lossType');
        if (missingKeys.length > 0) {
            const msg = `缺少必要参数: ${missingKeys.join(', ')}`;
            message.error(msg);
            window.alert(msg);
            return;
        }
        this.setState(
            {
                flowId,
                agentId,
                lossId,
                lossType
            },
            () => {
                this.setState({
                    visibleMoney: true
                });
            }
        );
    };

    viewEditAmountPaid = (initialValues, currentAgent, source, lossId, lossType = '') => {
        let resolvedLossType = lossType || '';
        if (!resolvedLossType) {
            const lossMeta = this.getLossMetaByLossId(initialValues, lossId);
            resolvedLossType = lossMeta.lossType || '';
        }
        this.showModalMoney(initialValues.flowId, currentAgent._id, lossId, resolvedLossType);
    };

    editClaimPaid = async (initialValues, currentAgent, lossId, lossType) => {
        const isSave = await this.onSave()
        if (!isSave) {
            return
        }
        const { source } = this.getLossMetaByLossId(initialValues, lossId)
        this.viewEditAmountPaid(initialValues, currentAgent, source, lossId, lossType)
    }

    handleOkMoney = (e) => {
        this.setState({
            visibleMoney: false
        });
    };
    handleCancelMoney = (e) => {
        this.setState({
            visibleMoney: false
        });
    };

    editAutoCalculate = async (initialValues, currentAgent, lossId, lossType) => {
        const isSave = await this.onSave()
        if (!isSave) {
            return
        }
        const { source } = this.getLossMetaByLossId(initialValues, lossId)
        this.autoCalculate(initialValues, currentAgent, source, lossId, lossType)
    }

    autoCalculate = async (initialValues, currentAgent, source, lossId, lossType) => {
        await autoCalculateClaimAmount.call(this, initialValues, currentAgent, source, lossId, lossType);
    };

    handleClaimItemFieldChange = (field, value, index) => {
        const { claimInfoList } = this.state
        const newClaimInfoList = [...claimInfoList]

        if (index >= 0 && index < newClaimInfoList.length) {
            newClaimInfoList[index] = { ...newClaimInfoList[index], [field]: value }
        }
        this.setState({ claimInfoList: newClaimInfoList })
    }

    // 提交核赔
    handleSubmitClaim = async () => {
        const { flowId, currentAgent } = this.props
        const { claimInfoList, selectedKey } = this.state

        if (!flowId) {
            message.error('flowId不存在')
            return
        }

        if (selectedKey === null || !claimInfoList[selectedKey]) {
            message.error('请选择计算书')
            return
        }

        const currentClaim = claimInfoList[selectedKey]
        const { claimBookNo, lossList = [] } = currentClaim

        // 校验lossList是否有数据
        if (lossList.length === 0) {
            message.error('请先添加损失信息')
            return
        }
        // 校验lossList中的item.claimResps是否有值
        for (const lossItem of lossList) {
            if (lossItem && ( !lossItem.claimResps || lossItem.claimResps.length === 0) ) {
                message.error('请补充损失项目')
                return
            }
        }

        // 校验是否所有损失信息都已选择
        const hasEmpty = lossList.some(loss => !loss.lossId || !loss.lossType)
        if (hasEmpty) {
            message.error('请完善损失信息')
            return
        }

        // 先保存
        const isSave = await this.onSave()
        if (!isSave) {
            return
        }

        try {
            const res = await submitClaimInfo({
                flowId,
                tenant: currentAgent.tenant?._id,
                claimBookNo
            })
            if (res.errCode === 0) {
                message.success('提交核赔成功')
            } else {
                message.error(res.errInfo || '提交核赔失败')
            }
        } catch (err) {
            message.error('提交核赔失败')
        } finally {
            await this.loadData()
        }
    }

    verifySave = (claimItem) => {
        // 校验 isPreMatch 是否必选
        if (!claimItem.isPreMatch) {
            return { isValid: false, message: '请选择是否预赔' }
        }
        if (!claimItem.opinion) {
            return { isValid: false, message: '请填写意见说明' }
        }

        // 校验 lossList 中的字段
        const lossList = claimItem.lossList || []
        if (lossList.length === 0) {
            return { isValid: false, message: '请添加损失信息' }
        }

        for (let i = 0; i < lossList.length; i++) {
            const loss = lossList[i]
            if (!loss.lossId) {
                return { isValid: false, message: `第${i + 1}个损失信息的损失方不能为空` }
            }
            if (!loss.lossType) {
                return { isValid: false, message: `第${i + 1}个损失信息的损失类型不能为空` }
            }
            if (!loss.paymentId) {
                return { isValid: false, message: `第${i + 1}个损失信息的领款人不能为空` }
            }
        }

        return { isValid: true, message: '' }
    }

    onSave = async () => {
        //保存/更新某一个计算书
        const { flowId } = this.props
        const { claimInfoList, selectedKey } = this.state
        if (!flowId) {
            this.setState({ initLoading: false })
            return false
        }
        let claimItem = claimInfoList[selectedKey]
        let verifyRes = this.verifySave(claimItem)
        if (!verifyRes.isValid) {
            message.warn(verifyRes.message)
            return false
        }
        try {
            // item只能包含部分数据
            let payload = {
                claimBookNo: claimItem.claimBookNo,
                isPreMatch: claimItem.isPreMatch,
                opinion: claimItem.opinion,
                lossList: claimItem.lossList
            }

            const result = await updateClaimInfoList({ flowId, item: payload  })
            if (result.errCode === 0) {
                this.setState({ initLoading: false })
                message.success('保存数据成功')
                await this.loadData()
                return true
            } else {
                message.error(result.msg || '更改数据失败')
                this.setState({ initLoading: false })
                return false
            }
        } catch (err) {
            this.setState({ initLoading: false })
            return false
        }
    }


    renderForm = () => {
        const { selectedKey, claimInfoList, paymentInfoList, selectList } = this.state
        const { actions, flowId, currentAgent, currentReport, show, initialValues } = this.props
        if (selectedKey === null || !claimInfoList[selectedKey]) {
            return <div className="empty-tip">请选择或新增理算书</div>
        }
        const hasAutoCalculatePermission = currentAgent.tenant.autoClaimPerms?.includes('showCalTrafficInsurance') || currentAgent.tenant.autoClaimPerms?.includes('showCalClaimPercent');
        const item = claimInfoList[selectedKey]
        const reviewOpinion = this.getReviewOpinion(item)
        return (
            <div className="claim-item-list">
                <div className="check-title-info">
                    <div className="add_update_tip">{item.isNew ? '新建计算书' : '编辑计算书'}</div>
                    <div>
                        <span className="right_info">计算书：{item.claimBookNo} 状态：{this.getStatus(item)}</span>
                    </div>
                </div>
                {
                    reviewOpinion && (
                        <div className="check-text">
                            审核意见：{reviewOpinion}
                        </div>
                    )
                }
               {/* 损失项*/}
                {
                    (!item.lossList || item.lossList.length === 0) && !this.props.disabled && (
                        <div className="loss-no-tip no-item">
                            <span>损失信息</span>
                            <span onClick={this.addLossItemClick}>添加</span>
                        </div>
                    )
                }
                {
                    item.lossList && item.lossList.map((item, index) => {
                        const matchTypes = selectList.find(selectInfo => {
                            return selectInfo.lossId === item.lossId
                        })
                        return (
                            <div className="loss-list-item">
                                <div className="loss-no-tip">
                                    <span>损失信息{index+1}</span>
                                    {
                                        !this.props.disabled && (
                                            <div>
                                                <span onClick={() => this.addLossItemClick()} style={{cursor: 'pointer'}}>添加 </span>
                                                <span onClick={() => this.removeLossItemClick(index)}  style={{cursor: 'pointer'}}>删除</span>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="loss-item-form">
                                    <div className="form-item">
                                        <span className="label"><span style={{ color: 'red' }}>*</span> 损失方</span>
                                        <Select
                                            placeholder="请选择"
                                            value={item.lossId}
                                            onChange={value => this.handleFieldChange('lossId', value, index)}
                                            style={{ width: '100%' }}
                                        >
                                            {
                                                selectList.map(selectInfo => {
                                                    return (<option value={selectInfo.lossId}>{selectInfo.name}</option>)
                                                })
                                            }
                                        </Select>
                                    </div>
                                    <div className="form-item">
                                        <span className="label"><span style={{ color: 'red' }}>*</span> 损失类型</span>
                                        <Select
                                            placeholder="请选择"
                                            value={item.lossType}
                                            onChange={value => this.handleFieldChange('lossType', value, index)}
                                            style={{ width: '100%' }}
                                        >
                                        {/* 损失类型的选择，需要根据损失人来筛选*/}
                                            {
                                                matchTypes?.types.map(lossType => {
                                                    return (<option value={lossType}>{lossTypeEnum[lossType]}</option>)
                                                })
                                            }
                                        </Select>
                                    </div>
                                    <div className="form-item">
                                        <span className="label"><span style={{ color: 'red' }}>*</span> 领款人</span>
                                        <Select
                                            placeholder="请选择"
                                            value={item.paymentId}
                                            onChange={value => this.handleFieldChange('paymentId', value, index)}
                                            style={{ width: '100%' }}
                                        >
                                            {
                                                paymentInfoList.map(paymentInfo => {
                                                    return (<option value={paymentInfo._id}>{paymentInfo.name}</option>)
                                                })
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="claim-code-item">
                                    {/*损失项目-编辑*/}
                                    {show !== 'detail' &&
                                        currentAgent.tenant.newClaimRespMode &&
                                        !['checked', 'finished'].includes(currentReport.state) &&
                                        !this.props.disabled && (
                                            <Row>
                                                <Col span={24}>
                                                    <a
                                                        style={{
                                                            marginTop: 10,
                                                            position: 'relative',
                                                            top: 29,
                                                            left: 60,
                                                            fontSize: 12,
                                                            zIndex: 999,
                                                            color: "#816cff",
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => this.editClaimCode(initialValues, currentAgent, item.lossId, item.lossType)}
                                                        type="link"
                                                    >
                                                        编辑
                                                    </a>
                                                </Col>
                                            </Row>
                                        )}
                                    {currentAgent.tenant.newClaimRespMode && (
                                        <Row>
                                            <Col span={24}>
                                                <AmountItemsTable claimResps={item.claimResps} />
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                                <div className="claim-code-next-item">
                                    {show !== 'detail' &&
                                        currentReport &&
                                        currentAgent.tenant.newClaimRespMode &&
                                        !['checked', 'finished'].includes(currentReport.state) &&
                                        !this.props.disabled && (
                                            <a
                                                style={{
                                                    marginTop: 20,
                                                    top: 29,
                                                    position: 'relative',
                                                    left: 59,
                                                    fontSize: 12,
                                                    color: "#816cff",
                                                    zIndex: 999,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() =>
                                                    this.editClaimPaid(
                                                        initialValues,
                                                        currentAgent,
                                                        item.lossId,
                                                        item.lossType
                                                    )
                                                }
                                                type="link"
                                            >
                                                编辑赔偿金额
                                            </a>
                                        )}

                                    {show !== 'detail' &&
                                        currentReport &&
                                        !['finished'].includes(currentReport.state) &&
                                        hasAutoCalculatePermission &&
                                        !this.props.disabled && (
                                            <a
                                                style={{
                                                    marginTop: 20,
                                                    top: 29,
                                                    left: 68,
                                                    position: 'relative',
                                                    fontSize: 12,
                                                    color: "#816cff",
                                                    zIndex: 999,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() =>
                                                    this.editAutoCalculate(
                                                        initialValues,
                                                        currentAgent,
                                                        item.lossId,
                                                        item.lossType
                                                    )
                                                }
                                                type="link"
                                            >
                                                自动计算
                                            </a>
                                        )}
                                    {currentAgent.tenant.newClaimRespMode && (
                                        <AmountItemsTableClaim claimResps={item.claimResps} />
                                    )}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    (!item.lossList || item.lossList.length !== 0) && (
                            <>
                                <div className="claim-ispre">
                                    <span className="label"><span style={{ color: 'red' }}>*</span> <span>是否预赔</span></span>
                                    <div className='pre_di'></div>
                                    <Radio.Group value={item.isPreMatch} onChange={e => this.handleClaimItemFieldChange('isPreMatch', e.target.value, selectedKey)}>
                                        <Radio value="1">是</Radio>
                                        <Radio value="2">否</Radio>
                                    </Radio.Group>
                                </div>
                                <div className="claim-opinion">
                                    <span className="label"><span style={{ color: 'red' }}>*</span> <span>意见说明</span></span>
                                    <div className='pre_di'></div>
                                    <TextArea value={item.opinion} onChange={e => this.handleClaimItemFieldChange('opinion', e.target.value, selectedKey)} placeholder='请输入'/>
                                </div>
                                <div className={`btn-actions ${!this.canSubmit(item) || this.props.disabled ? 'no-border' : ''}`}>
                                    {
                                        this.canSubmit(item) && !this.props.disabled && (
                                            <Button type="primary" style={{marginRight: '15px'}} onClick={e => this.onSave()}>保存</Button>
                                        )
                                    }
                                    {
                                        this.canSubmitClaim(item) && !this.props.disabled && (
                                            <Button type="primary" onClick={this.handleSubmitClaim}>提交核赔</Button>
                                        )
                                    }
                                </div>
                            </>
                    )
                }
            </div>
        )
    }

    getStatus = (item) => {
        if (item.innerClaimStatus !== 'APPROVED') {
            return innerClaimStatusEnum[item.innerClaimStatus]
        }
        if (item.insureCompClaimStatus !== 'INSURE_APPROVED') {
            return insureCompClaimStatusEnum[item.insureCompClaimStatus]
        }
        return paymentStatusEnum[item.paymentStatus] || insureCompClaimStatusEnum[item.insureCompClaimStatus]
    }

    getLossInfoList = (selectedKey) => {
        const { claimInfoList } = this.state
        const { initialValues } = this.props

        if (selectedKey === null || !claimInfoList[selectedKey]) {
            return { personLossList: [], vehicleLossList: [], propertyLossList: [] }
        }

        const currentClaim = claimInfoList[selectedKey]
        const lossList = currentClaim.lossList || []

        // 从 initialValues 获取车辆信息
        const { ownCarLoss, otherCarLoss = [] } = initialValues || {}
        const allLosses = [ownCarLoss, ...otherCarLoss]

        const personLossList = []
        const vehicleLossList = []
        const propertyLossList = []

        lossList.forEach(lossItem => {
            const { lossId, lossType } = lossItem
            if (!lossId) return

            // 根据 lossId 匹配损失信息
            const matchedLoss = allLosses.find(loss =>
                loss && loss._id && lossId && loss._id.toString() === lossId.toString()
            )
            if (!matchedLoss || !matchedLoss.cpicLoss) return

            const { cpicLoss, carOwner, carNumber } = matchedLoss

            if (lossType === "injury") {
                personLossList.push(carOwner)
            } else if (lossType === "damage") {
                propertyLossList.push(cpicLoss.damageName)
            } else if (lossType === "carLoss") {
                vehicleLossList.push(carNumber)
            }
        })

        return { personLossList, vehicleLossList, propertyLossList }
    }
    getLossItemName = (index) => {
        const existInfos = []
        const info = this.getLossInfoList(index)
        if (info.personLossList && info.personLossList.length > 0) {
            existInfos.push({
                lossType: lossTypeEnum.injury,
                arr: info.personLossList
            })
        }
        if (info.vehicleLossList && info.vehicleLossList.length > 0) {
            existInfos.push({
                lossType: lossTypeEnum.carLoss,
                arr: info.vehicleLossList
            })
        }
        if (info.propertyLossList && info.propertyLossList.length > 0) {
            existInfos.push({
                lossType: lossTypeEnum.damage,
                arr: info.propertyLossList
            })
        }
        return existInfos
    }
    isFail = (item) => {
        if (item && ['REJECTED'].includes(item.innerClaimStatus)) {
            return true
        }
        return item && (
            ['INSURE_REJECTED', 'INSURE_PAYMENT_FAILED'].includes(item.insureCompClaimStatus)
            || ['refound', '2'].includes(item.paymentStatus)
        );

    }

    render() {
        const { claimInfoList, selectedKey, initLoading } = this.state
        return (
            <div className="claim-info-list-container">
                <div className="left-panel">
                    <div className="add-btn">
                        {
                            !this.props.disabled && (
                                <Button
                                    type="primary"
                                    onClick={this.handleAdd}
                                >
                                    + 新增理算书
                                </Button>
                            )
                        }
                    </div>
                    <div className="menu-list">
                        {claimInfoList.map((item, index) => (
                            <div
                                key={index}
                                className={`menu-item ${selectedKey === index ? 'active' : ''} ${item.isNew ? 'new-item' : 'edit-item'} ${this.isFail(item) ? 'fail-item' : ''}`}
                                onClick={() => this.handleSelect(index)}
                            >
                                {
                                    item.isNew ? <span className="name">待保存</span> : (
                                        //卡片格式
                                        <div className={`card-menu ${this.isFail(item) ? 'fail-style' : ''}`}>
                                            <div className="card-no">{item.claimBookNo}</div>
                                            <div className="card-item-content">
                                                {
                                                    this.getLossItemName(index).map(item => {
                                                        if (item.lossType === lossTypeEnum.injury) {
                                                            return (
                                                                <div className="injury-content">
                                                                    人伤：{item.arr.join('、')}
                                                                </div>
                                                            )
                                                        }
                                                        if (item.lossType === lossTypeEnum.carLoss) {
                                                            return (
                                                                <div className="carLoss-content">
                                                                    车损：{item.arr.join('、')}
                                                                </div>
                                                            )
                                                        }
                                                        if (item.lossType === lossTypeEnum.damage) {
                                                            return (
                                                                <div className="damage-content">
                                                                    物损：{item.arr.join('、')}
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                                <div className="card-status">
                                                    <div className="status">状态：{this.getStatus(item)}</div>
                                                    <div className={`is_pre_btn ${item.isPreMatch === '1' ? '' : 'final'}`}>{item.isPreMatch === '1' ? '预赔': '终赔'}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        ))}
                    </div>
                </div>
                <div className="right-panel">
                    {this.renderForm()}
                </div>
                <Modal
                    destroyOnClose
                    title="编辑赔偿金额"
                    visible={this.state.visibleMoney}
                    onOk={this.handleOkMoney}
                    onCancel={this.handleCancelMoney}
                    width={'60%'}
                    footer={null}
                >
                    <div>
                        <iframe
                            id="editAmountItemsIframe"
                            style={{ border: 'none' }}
                            src={
                                config.domainForIframe +
                                '/edit-amount-paid' +
                                '?agentId=' +
                                this.props.currentAgent._id +
                                '&flowId=' +
                                this.state.flowId +
                                '&lossId=' +
                                this.state.lossId +
                                '&lossType=' +
                                (this.state.lossType || '') +
                                '&token=' + window.btoa(window.accessToken)
                            }
                            width="100%"
                            height="100%"
                            frameborder="0"
                        ></iframe>
                    </div>
                </Modal>
            </div>
        )
    }
}


export default ClaimInfoList
